import Button from 'components/Button/Button';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openJoinEmployeeToProjectDialog } from 'store/projectUsers/actions/project-users.actions';
import { JoinExistingEmployeeToProjectDialog } from './JoinExistingEmployeeToProjectDialog';
import { selectIsJoinEmployeeToProjectDialogOpen } from 'store/projectUsers/selectors/projectUsers.selectors';

export const OpenJoinEmployeeToProjectDialogButton = ({
  projectId,
  createRecordForUser = false,
}) => {
  const dispatch = useDispatch();

  const isJoinEmployeeToProjectDialogOpen = useSelector(
    selectIsJoinEmployeeToProjectDialogOpen
  );

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={() =>
          dispatch(
            openJoinEmployeeToProjectDialog({
              createRecordForUser,
              projectId,
            })
          )
        }
      >
        {'Liitä työntekijä'}
      </Button>
      {isJoinEmployeeToProjectDialogOpen ? (
        <JoinExistingEmployeeToProjectDialog
          projectId={projectId}
        ></JoinExistingEmployeeToProjectDialog>
      ) : null}
    </div>
  );
};
